/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_No_RoundInputs */

const en_us2_clubs_no_round = /** @type {(inputs: Clubs_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No round running`)
};

const pt_br2_clubs_no_round = /** @type {(inputs: Clubs_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem rodada em andamento`)
};

const es_419_clubs_no_round = /** @type {(inputs: Clubs_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguna ronda en curso`)
};

const pt_pt2_clubs_no_round = /** @type {(inputs: Clubs_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma ronda a decorrer`)
};

const fr_fr2_clubs_no_round = /** @type {(inputs: Clubs_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune manche en cours`)
};

const de_de2_clubs_no_round = /** @type {(inputs: Clubs_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine laufende Runde`)
};

const it_it2_clubs_no_round = /** @type {(inputs: Clubs_No_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun turno in corso`)
};

/**
* | output |
* | --- |
* | "No round running" |
*
* @param {Clubs_No_RoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_no_round = /** @type {((inputs?: Clubs_No_RoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_No_RoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_no_round(inputs)
	if (locale === "es-419") return es_419_clubs_no_round(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_no_round(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_no_round(inputs)
	if (locale === "de-DE") return de_de2_clubs_no_round(inputs)
	if (locale === "it-IT") return it_it2_clubs_no_round(inputs)
	return en_us2_clubs_no_round(inputs)
});
export { clubs_no_round as "clubs.no_round" }